import React from "react";
import { createRoot } from "react-dom/client";
import { marked } from "marked";
import App from "./App";
import "./styles.css";

marked.setOptions({
  breaks: true,
  gfm: true,
});

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
